var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDetail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 21C16.9706 21 21 16.9706 21 12C21 7.02944 16.9706 3 12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21Z",
    stroke: "#666666",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 7.5V12.75",
    stroke: "#666666",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.0625 16.125C13.0625 16.7118 12.5868 17.1875 12 17.1875C11.4132 17.1875 10.9375 16.7118 10.9375 16.125C10.9375 15.5382 11.4132 15.0625 12 15.0625C12.5868 15.0625 13.0625 15.5382 13.0625 16.125Z",
    fill: "#666666",
    stroke: "#666666",
    strokeWidth: 0.125
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDetail);
export default __webpack_public_path__ + "static/media/detail.ecc51810b432486bc249f41a68574d55.svg";
export { ForwardRef as ReactComponent };